import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const USE_LOCAL_SERVER = false;
const API_BASE_URL = USE_LOCAL_SERVER ? 'http://127.0.0.1:5010' : 'https://api.obriy.ai';

export default function App() {
  const { pageId, secret } = useParams();
  const [markdown, setMarkdown] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchMarkdown() {
      try {
        const res = await fetch(
          `${API_BASE_URL}/assistant_api/v1/pages/${pageId}/${secret}/content`,
        );
        if (!res.ok) throw new Error(`Failed to load content — ${res.status}`);
        const payload = await res.json();
        setMarkdown(payload.content);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchMarkdown();
  }, [pageId, secret]);

  if (loading) {
    return (
      <div className="min-h-screen grid place-content-center">
        <span className="animate-pulse text-xl">Loading…</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen grid place-content-center text-red-600">
        <p className="text-lg font-semibold">Error</p>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <main className="sure-page-wrapper">
      <section className="page-content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
          components={{
            a: ({ node, ...props }) => (
              <a {...props} target="_blank" rel="noopener noreferrer">
                {props.children}
              </a>
            ),
          }}
        >
          {markdown}
        </ReactMarkdown>
      </section>
    </main>
  );
}
